import { useState } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import { getCurrentDispensary } from "redux/selectors/dispensary";

import Image from "components/Image";
import LightBox from "components/LightBox";

const PhotoOverview: React.FC<{ className?: string }> = ({ className }) => {
  const { name, photos } = useSelector(getCurrentDispensary);

  const [showLightbox, setShowLightbox] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  if (!photos || !photos.length) {
    return null;
  }

  const toggleLightbox = (index = 0) => {
    setPhotoIndex(index);
    setShowLightbox(!showLightbox);
  };

  return (
    <>
      <div className={classnames(className)}>
        {showLightbox && (
          <LightBox
            images={photos}
            initialPhotoIndex={photoIndex || 0}
            onToggleLightboxClick={toggleLightbox}
          />
        )}
        <h2 className="mb-sm">{`Photos of ${name}`}</h2>
        <div className="row mb-md">
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate */}
          {photos.slice(0, 4).map((photo: any, i: number) => (
            <button
              className="col-1/2 md:col-1/4 relative mb-md md:mb-none"
              key={photo.imageUrl}
              onClick={() => toggleLightbox(i)}
              aria-label="View enlarged photo in lightbox"
            >
              <Image
                sizes={[250, 360, 175, 240, null, 250]}
                src={photo.imageUrl}
                alt={name}
                ratio="square"
              />
            </button>
          ))}
        </div>
        <div
          tabIndex={0}
          role="button"
          onClick={() => toggleLightbox(0)}
          onKeyPress={() => toggleLightbox(0)}
          className="font-bold text-green text-sm"
        >
          Show all photos
        </div>
      </div>
    </>
  );
};

export default PhotoOverview;
